import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { ModifierPriority } from '../../modifier.type';
import type { Die, DieCreation } from '../../die.type';

export class ElementalSynergyTrait extends Trait {
  static baseType = TraitType.ElementalSynergy;
  static baseTitle = 'Elemental Synergy';
  static baseText = 'Lowers the level of each die by 1.';
  static baseIcon = 'trait';
  static basePriority = ModifierPriority.First;

  type = ElementalSynergyTrait.baseType;
  title = ElementalSynergyTrait.baseTitle;
  text = ElementalSynergyTrait.baseText;
  icon = ElementalSynergyTrait.baseIcon;

  getDice(dice: Array<Die>): Array<DieCreation> {
    dice.forEach((die) => {
      die.level--;
    });
    return [];
  }
}

TraitRegistry.register(ElementalSynergyTrait.baseType, ElementalSynergyTrait);
